$(document).ready(function () {
  gsap.registerPlugin(ScrollTrigger);
  const technologySection = $(".technology-mini");
  const listItems = $(".inside-tech-list__item");

  let tl;

  function technologyScroll() {
    if (tl) tl.revert();
    tl = gsap.timeline({
      scrollTrigger: {
        trigger: technologySection,
        start: "top center",
        end: `bottom bottom`,
        scrub: 1,
        once: false,
        invalidateOnRefresh: true,
      },
    });
    listItems.each((index, el) => {
      tl.fromTo(
        el,
        {
          y: 50,
          opacity: 0,
          duration: 2,
        },
        {
          y: 0,
          opacity: 1,
          ease: "power3.out",
          duration: 2
        }
      );
    });
  }
  let lw;
  window.addEventListener("resize", function () {
    if (lw != window.innerWidth) {
      if (tl) {
        tl.revert();
        tl.clear();
      }
      technologyScroll();
    }
    lw = window.innerWidth;
  });
  technologyScroll();


  
  
});
